<script lang="ts" setup>
  import { RoutingView } from '@tundr/routing';
</script>

<template>
  <RoutingView />
</template>
